import React, { PropsWithChildren, useCallback, useEffect } from 'react';

import { cleanInternalLinkUrl } from '../../../utils/cob-utils';
import SessionStorage from '../../../utils/SessionStorage';
import { IPartnerOfferFormProps } from '../PartnerOfferForm';


interface IPhaVariantProps extends IPartnerOfferFormProps {
    applicationPagePath?: string;
}

export const PhaVariant = (props: PropsWithChildren<IPhaVariantProps>): JSX.Element => {
    useEffect(() => {
        SessionStorage.remove('offerId');
        SessionStorage.remove('pqOfOneAuthorizedUserShowing');
    }, []);

    const paramSubmit = useCallback(() => {
        const find = (key: string) => {
            const a = document.querySelector<HTMLInputElement>(`input[name="${key}"]`);
            if (a && a.value) {
                return a.value;
            }
        };
        const params = [];

        const sourceId = find('sourceId');
        sourceId && params.push('sourceId=' + sourceId);
        
        const offerId = find('offerId');
        offerId && params.push('offerId=' + offerId);

        const descriptorId = find('descriptorId');
        descriptorId && params.push('descriptorId=' + descriptorId);

        window.location.assign(cleanInternalLinkUrl(props.applicationPagePath + '.html') + (params.length > 0 ? '?' + params.join('&') : ''));
    }, []);

    return (
        <form id='partner-offer-form' className={'PartnerOfferForm PhaVariant'} action={cleanInternalLinkUrl(props.applicationPagePath + '.html')} method={'POST'}>
            <label className={'PartnerOfferForm__label'}>
                Offer ID:
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'offerId'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Source ID:
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'sourceId'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Descriptor ID:
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'descriptorId'} />
            </label>
            <input className={'PartnerOfferForm__submit'} type={'submit'} value={'Submit POST'} />
            <input className={'PartnerOfferForm__submit'} type={'button'} value={'Submit Params'} onClick={paramSubmit} />

            <span className={'PartnerOfferForm__applicantInfoLabel PartnerOfferForm__appInfoHeader'}>
                -- Section Overrides (Optional) --
            </span>
            <span className={'PartnerOfferForm__applicantInfoLabel'}>
                -- Any sections that are checked will be forced to show --
            </span>
            <label className={'PartnerOfferForm__label'}>
                <input
                    className={'PartnerOfferForm__checkbox'}
                    type='checkbox'
                    name={'AuthorizedUserCheck'} />
                Authorized User
            </label>
            <br/>
            <span className={'PartnerOfferForm__applicantInfoLabel PartnerOfferForm__appInfoHeader'}>
                -- Applicant Info (Optional) --
            </span>
            <span className={'PartnerOfferForm__applicantInfoLabel'}>
                -- Using the following fields will overwrite the response from the applicant info API --
            </span>
            <label className={'PartnerOfferForm__label'}>
                Program Code
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'ProgramCode'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                First Name
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'FirstName'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Last Name
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'LastName'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Middle Initial
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'MiddleInitial'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Date Of Birth (Month/Day/Year)
                <br/>
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__dob'}
                    type='text'
                    name={'DobMonth'} />
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__dob'}
                    type='text'
                    name={'DobDay'} />
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__dob'}
                    type='text'
                    name={'DobYear'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Email Address
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'Email'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                SSN (Last 4)
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__input--short'}
                    type='text'
                    maxLength={4}
                    name={'SSN'} />
            </label>
            <br/>
            <span className={'PartnerOfferForm__addressHeader'}>Mailing Address</span>
            <label className={'PartnerOfferForm__label'}>
                Address Line 1
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'MailingAddress1'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Address Line 2
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'MailingAddress2'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                City
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'MailingCity'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                State (Abbreviated, e.g. NV)
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__input--short'}
                    type='text'
                    maxLength={2}
                    name={'MailingState'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Zip Code
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__input--short'}
                    type='text'
                    maxLength={5}
                    name={'MailingZip'} />
            </label>
            <br/>
            <span className={'PartnerOfferForm__addressHeader'}>Home Address</span>
            <label className={'PartnerOfferForm__label'}>
                Address Line 1
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'HomeAddress1'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Address Line 2
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'HomeAddress2'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                City
                <input
                    className={'PartnerOfferForm__input'}
                    type='text'
                    name={'HomeCity'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                State (Abbreviated, e.g. NV)
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__input--short'}
                    type='text'
                    maxLength={2}
                    name={'HomeState'} />
            </label>
            <br/>
            <label className={'PartnerOfferForm__label'}>
                Zip Code
                <input
                    className={'PartnerOfferForm__input PartnerOfferForm__input--short'}
                    type='text'
                    maxLength={5}
                    name={'HomeZip'} />
            </label>
            <br/>
            <input className={'PartnerOfferForm__submit'} type={'submit'} value={'Submit'} />
        </form>
    );
};
